import DataSource from "./DataSource";

export default class RecordSource extends DataSource {

  constructor(resource, server, method, config = {}){
    super(server, method, config);
    this.resource = resource;
  }

  _load(result){
    this.result = result.map(item => this.resource.getRecord(item));
  }

  pushRaw(item){
    this.push(this.resource.getRecord(item));
  }

}


// WEBPACK FOOTER //
// ./src/DataSource/RecordSource.js